import { IconDefinition } from '@ant-design/icons-angular';

export const EllipsisOutline: IconDefinition = {
    name: 'ellipsis',
    theme: 'outline',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" /></svg>'
}